import { Injectable } from '@angular/core'
import {
  CommandService,
  EventService,
  GlobalMessageService,
  GlobalMessageType,
  isNotNullable,
  UserIdService
} from '@spartacus/core'
import { MbCheckoutQuoteInfoFacade } from '../facades/mb-checkout-quote-info.facade'
import { MbQuoteInfoModel } from '../../models'
import { catchError, filter, switchMap, tap, withLatestFrom } from 'rxjs/operators'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { MbCheckoutQuoteInfoConnector } from '../connectors/quote-info'
import { CheckoutQuoteInfoSetEvent } from '../../analytics/events/mb-checkout.events'
import { take } from 'rxjs/operators'
import { EMPTY } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class MbCheckoutQuoteInfoService implements MbCheckoutQuoteInfoFacade {

  userId$ = this.userIdService.getUserId()
  cartId$ = this.activeCartService.getActiveCartId()

  constructor (protected userIdService: UserIdService,
               protected activeCartService: ActiveCartFacade,
               protected globalMessageService: GlobalMessageService,
               protected commandService: CommandService,
               protected eventService: EventService,
               protected mbCheckoutQuoteInfoConnector: MbCheckoutQuoteInfoConnector) {
  }

  postQuoteInfoDetails (quoteInfoDetails: MbQuoteInfoModel) {
    this.commandService.create(() =>
      this.userId$.pipe(
        take(1),
        tap(userId => !userId && this.globalMessageService.add({ key: 'quoteInfo.error' }, GlobalMessageType.MSG_TYPE_ERROR)),
        filter(isNotNullable),
        withLatestFrom(this.cartId$),
        filter(([userId, cartId]) => !!cartId),
        switchMap(([userId, cartId]) => this.mbCheckoutQuoteInfoConnector.post(quoteInfoDetails, cartId).pipe(
          tap(() => this.eventService.dispatch({ isSuccessful: true }, CheckoutQuoteInfoSetEvent)),
          catchError(error => {
            this.eventService.dispatch({ isSuccessful: false, error: error }, CheckoutQuoteInfoSetEvent)
            return EMPTY
          })
        ))
      )).execute(undefined)
  }
}
